import { apiFetch } from '@/lib/api-client';
import type { ProspectDetail, ProspectListItem } from '@/lib/prospects-model';

export { salesProspectPath } from '@/lib/prospects-model';
export type { ProspectDetail, ProspectListItem };

export type ProspectsListResponse = {
  items: ProspectListItem[];
  count: number;
  correlationId?: string;
};

export type ProspectDetailResponse = ProspectDetail & {
  correlationId?: string;
};

export async function fetchProspects(email?: string): Promise<ProspectsListResponse> {
  const query = email?.trim() ? `?email=${encodeURIComponent(email.trim())}` : '';
  return apiFetch<ProspectsListResponse>(`/prospects${query}`);
}

export async function fetchProspectById(prospectId: string): Promise<ProspectDetailResponse> {
  return apiFetch<ProspectDetailResponse>(`/prospects/${encodeURIComponent(prospectId)}`);
}
